import React, { useState } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { resources } from "../Resourses/Resources"; // Ensure this path is correct

const errorMessage = (message) => {
  toast.error(message, {
    toastId: "error1",
    className: "error",
  });
};

const successMessage = (message) => {
  toast.success(message, {
    toastId: "success1",
    className: "success",
  });
};

const Login = () => {
  const [login, setLogin] = useState({ username: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleChangeLogin = (e) => {
    e.preventDefault();
    setLogin({
      ...login,
      [e.target.name]: e.target.value,
    });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(resources.AUTHORIZE_URL + "signin", login);
      const userDetails = response.data;
      
      // Store user data in cookies after successful login
      Cookies.set("userDetails", JSON.stringify(userDetails));

      // Show success message
      successMessage("Login Successful");

      // Redirect based on user role
      if (userDetails.roles[0] === "ROLE_FACULTY" || userDetails.roles[0] === "ROLE_HOD") {
        navigate("/facultyUploads");
      } else if (userDetails.roles[0] === "ROLE_ADMIN") {
        navigate("/admin/DashboardView");
      } else if (userDetails.roles[0] === "ROLE_STUDENT") {
        navigate("/gallery/studentDashboard/view");
      } else {
        navigate("/");
      }
    } catch (error) {
      if (error.response && error.response.data) {
        errorMessage(error.response.data.message);
      } else {
        errorMessage("Something went wrong. Please try again.");
      }
    }
  };

  return (
    <div className="container">
      <div className="login-root">
        <div className="box-root flex-flex flex-direction--column" style={{ minHeight: "fit-content", flexGrow: 1 }}>
          <div className="box-root padding-top--24 flex-flex flex-direction--column" style={{ flexGrow: 1, zIndex: 9 }}>
            <div className="box-root padding-top--48 padding-bottom--24 flex-flex flex-justifyContent--center">
              <h1>LOGIN</h1>

            </div>
            <div className="formbg-outer">
              <div className="formbg">
                <div className="formbg-inner padding-horizontal--48">
                  <span className="padding-bottom--15">Sign in to your account</span>
                  <form id="stripe-login">
                    <div className="field padding-bottom--24">
                      <label htmlFor="userName">User Name</label>
                      <input
                        type="text"
                        name="username"
                        value={login.username}
                        onChange={(e) => handleChangeLogin(e)}
                      />
                    </div>
                    <div className="field padding-bottom--24">
                      <label htmlFor="password">Password</label>
                      <input
                        type={showPassword ? "text" : "password"}
                        name="password"
                        value={login.password}
                        onChange={(e) => handleChangeLogin(e)}
                      />
                    </div>
                    <div className="field field-checkbox padding-bottom--24 flex-flex align-center">
                      <label htmlFor="checkbox">
                        <input type="checkbox" name="checkbox" onChange={togglePasswordVisibility} /> Show Password
                      </label>
                    </div>
                    <div className="field padding-bottom--24">
                      <input
                        type="submit"
                        name="submit"
                        value="Login"
                        onClick={handleLogin}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
